import React from "react";
import {
  SimpleGrid,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionIcon,
  AccordionPanel,
  Accordion,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import useBear from "hooks/useBear";
import Attribute from "components/Attribute";
import TinyHeading from "components/TinyHeading";

const BearAttributesContainer = () => {
  const translate = useTranslate();
  const { metadata } = useBear();

  return metadata?.attributes && metadata.attributes.length > 0 ? (
    <Accordion w="full" allowToggle defaultIndex={0}>
      <AccordionItem border="none">
        <AccordionButton
          py="3"
          bg="bright.600"
          _hover={{ bg: "bright.700" }}
          position="relative"
        >
          <Box flex="1" textAlign="left">
            <TinyHeading opacity="1">
              {translate("bearsAttrs:label", {
                count: metadata.attributes.length,
              })}
            </TinyHeading>
          </Box>

          <AccordionIcon w="6" h="auto" position="absolute" right="3" />
        </AccordionButton>

        <AccordionPanel p="3" bg="bright.500">
          <SimpleGrid columns={{ base: 2, sm: 3 }} gap="3">
            {metadata.attributes.map((attribute, i) => (
              <Attribute key={i} attribute={attribute} />
            ))}
          </SimpleGrid>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  ) : null;
};

export default BearAttributesContainer;
